import { db, type LocalContract } from '../db';
import axiosInstance from '../api/axios';

export const syncContractsToLocal = async (companyId: string) => {
    try {
        // Fetch active contracts (simplified endpoint needed or filter locally)
        // Ideally backend provides /contracts/active-vehicles or similar
        // For now we assume fetch all active contracts
        const response = await axiosInstance.get('/contracts'); // Might need query params for active only
        const contracts: any[] = response.data; // Assuming it returns list of contracts

        // We need to flatten contracts to vehicles for easy lookup
        // Assuming contract structure has contractVehicles relation
        const localContracts: LocalContract[] = [];

        contracts.forEach((contract) => {
            if (contract.status === 'ACTIVO' && contract.contractVehicles) {
                contract.contractVehicles.forEach((cv: any) => {
                    localContracts.push({
                        id: contract.id, // We use contract ID, but could be unique ID per vehicle-contract link
                        placa: cv.vehiculo.placa,
                        companyId: contract.companyId,
                        fechaInicio: contract.fechaInicio,
                        fechaFin: contract.fechaFin,
                        status: contract.status,
                        clienteNombre: contract.cliente
                    });
                });
            }
        });

        // Clear existing contracts for this company to avoid stale data
        await db.contracts.where({ companyId }).delete();

        if (localContracts.length > 0) {
            await db.contracts.bulkAdd(localContracts);
        }

        console.log(`✅ Synced ${localContracts.length} active contract vehicles to Dexie`);
        return true;
    } catch (error) {
        console.error('Error syncing contracts:', error);
        return false;
    }
};
